import dayjs from 'dayjs'
import 'dayjs/locale/fr-ca'
import 'dayjs/locale/en-ca'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import CustomParseFormat from 'dayjs/plugin/customParseFormat'
import RelativeTime from 'dayjs/plugin/relativeTime'
import Utc from 'dayjs/plugin/utc'
import Timezone from 'dayjs/plugin/timezone'
import DevHelper from "dayjs/plugin/devHelper";
import {getCurrentLang} from "config/i18n.ts";
import ajax from "config/ajax.ts";

dayjs.locale(`${getCurrentLang()}-ca`)
dayjs.extend(LocalizedFormat)
dayjs.extend(CustomParseFormat)
dayjs.extend(RelativeTime)
dayjs.extend(Utc)
dayjs.extend(Timezone)


if (process.env.NODE_ENV !== 'production') {
    dayjs.extend(DevHelper)
}

ajax.defaults.headers.common["x-timezone"] = dayjs.tz.guess()
